import React from "react";

import {
    FootNote,
    SizeCell,
    SplitCaKingCell,
    SplitKingCell,
    sizeIcons,
} from "./_shared";

/**
 * Native port of ``cms/blocks/product-specifications/adapt.html`` (#33410).
 */
export const Adapt = (): React.JSX.Element => (
    <div className="adapt-specifications">
        <SizeCell
            icon={sizeIcons.adaptTwin}
            heading="Twin"
            lines={['38" x 74"', "Single Mattress", "42-61 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptTwinXl}
            heading="Twin Long"
            lines={['38" x 80"', "Single Mattress", "45-64 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptDouble}
            heading="Full/Double"
            lines={['53" x 74"', "Single Mattress", "58-85 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptQueen}
            heading="Queen"
            lines={['60" x 80"', "Single Mattress", "70-103 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptKing}
            heading="King"
            lines={['76" x 80"', "Single Mattress", "89-131 lbs"]}
        />
        <SplitKingCell lines={['76" x 80"', "Double Mattress", "90-128 lbs"]} />
        <SizeCell
            icon={sizeIcons.adaptCaKing}
            heading="CA King"
            lines={['72" x 84"', "Single Mattress", "89-131 lbs"]}
        />
        <SplitCaKingCell
            lines={['72" x 84"', "Double Mattress", "92-138 lbs"]}
        />

        <FootNote />
    </div>
);
